import { IItemForGetShortInfo, ITeaserDishTransition } from 'types';
import GameCategorySelect from './components/GameCategorySelect';
import GameNameSelect from './components/GameNameSelect';
import DishNameSelect from './components/DishNameSelect';
import DishSubCategorySelect from './components/DishSubCategorySelect';
import TransitionTypeSwitch from './components/TransitionTypeSwitch';
import DishCategorySelect from './components/DishCategorySelect';
import { TEditTeaserTransitionType } from 'modules/Teasers/EditTeaser/editTeaserState/editTeaserContext';
import React from 'react';

interface ITransitionTypeField {
	selectedRestaurants: string[];
	setTransitionType: (value: TEditTeaserTransitionType) => void;
	setTransitionDishCategory: (value: Nullable<string>) => void;
	setFetchedDishCategories: (value: IItemForGetShortInfo[]) => void;
	selectedTransitionDishCategory: Nullable<string>;
	setTransitionDishSubCategory: (value: Nullable<string>) => void;
	setFetchedDishSubCategories: (value: IItemForGetShortInfo[]) => void;
	selectedTransitionDishSubCategory: Nullable<string>;
	setTransitionDishName: (value: Nullable<string>) => void;
	setFetchedDishes: (value: IItemForGetShortInfo[]) => void;
	setTransitionGameCategory: (value: Nullable<string>) => void;
	setFetchedGameCategories: (value: IItemForGetShortInfo[]) => void;
	selectedTransitionGameCategory: Nullable<string>;
	setTransitionGameName: (value: Nullable<string>) => void;
	setFetchedGames: (value: IItemForGetShortInfo[]) => void;
	selectedTransitionType: TEditTeaserTransitionType;
	dishTransition: Nullable<ITeaserDishTransition>;
	selectedTransitionDishName: Nullable<string>;
}

const TransitionTypeField: React.FC<ITransitionTypeField> = ({
	selectedRestaurants,
	setTransitionType,
	setTransitionDishCategory,
	setFetchedDishCategories,
	selectedTransitionDishCategory,
	setTransitionDishSubCategory,
	setFetchedDishSubCategories,
	selectedTransitionDishSubCategory,
	setFetchedDishes,
	setTransitionDishName,
	setTransitionGameCategory,
	setFetchedGameCategories,
	selectedTransitionGameCategory,
	setTransitionGameName,
	setFetchedGames,
	selectedTransitionType,
	dishTransition,
	selectedTransitionDishName,
}) => {
	const renderDishFields = () => {
		return (
			<>
				<DishCategorySelect
					selectedRestaurants={selectedRestaurants}
					dishTransition={dishTransition}
					selectedTransitionDishCategory={selectedTransitionDishCategory}
					setFetchedDishCategories={setFetchedDishCategories}
					setTransitionDishCategory={setTransitionDishCategory}
				/>
				<DishSubCategorySelect
					selectedTransitionDishCategory={selectedTransitionDishCategory}
					setTransitionDishSubCategory={setTransitionDishSubCategory}
					setFetchedDishSubCategories={setFetchedDishSubCategories}
				/>
				<DishNameSelect
					selectedRestaurants={selectedRestaurants}
					selectedTransitionDishSubCategory={selectedTransitionDishSubCategory}
					dishTransition={dishTransition}
					selectedTransitionDishName={selectedTransitionDishName}
					setFetchedDishes={setFetchedDishes}
					setTransitionDishName={setTransitionDishName}
				/>
			</>
		);
	};

	const renderGameFields = () => {
		return (
			<>
				<GameCategorySelect
					selectedRestaurants={selectedRestaurants}
					setFetchedGameCategories={setFetchedGameCategories}
					setTransitionGameCategory={setTransitionGameCategory}
				/>
				<GameNameSelect
					selectedRestaurants={selectedRestaurants}
					selectedTransitionGameCategory={selectedTransitionGameCategory}
					setFetchedGames={setFetchedGames}
					setTransitionGameName={setTransitionGameName}
				/>
			</>
		);
	};

	const showDishFields = selectedTransitionType === 'dish';
	const showGameFields = selectedTransitionType === 'game';

	return (
		<>
			<TransitionTypeSwitch setTransitionType={setTransitionType} />
			{showDishFields && renderDishFields()}
			{showGameFields && renderGameFields()}
		</>
	);
};

export default React.memo(TransitionTypeField);
